import React from 'react'

const CheckoutPlaceholder = props => (
  <div className='container-cart container py-md-5 py-0 px-md-1 px-0'>
    <div className='row mx-0'>
      <div className='checkout-side col-12 col-md-8 pl-0 pr-md-2 pr-0 mt-5 pt-2 mt-md-0 pt-md-0'>
        <div className='border-ui-3 radius bg-white'>
          <div className='row mx-0'>
            <div className='col-12 checkout-step row px-2 border-bottom border-color-ui-3 mx-0'>
              <div className='col-auto px-1'>
                <div className='row mx-0 align-items-center h-100'>
                  <div className='col-1 px-2 radius bg-ui-3 py-2' />
                </div>
              </div>
              <div className='col'>
                <div className='row mx-0 align-items-center h-100'>
                  <div className='col-1 px-5 radius bg-ui-3 py-1' />
                </div>
              </div>
            </div>
            <div className='col-12 row mx-0 pb-2 border-bottom border-color-ui-3 bg-ui-5'>
              <div className='profile-infos col-12 px-2'>
                <div className='row mx-0'>
                  <div className='col-3 radius bg-ui-3 py-1 mt-1 mr-1' />
                  <div className='col-3 radius bg-ui-3 py-1 mt-1 mr-1' />
                </div>
                <div className='row mx-0'>
                  <div className='col-sm radius bg-ui-3 py-2 mt-1 mr-1' />
                  <div className='col-sm radius bg-ui-3 py-2 mt-1' />
                </div>
                <div className='row mx-0'>
                  <div className='col-sm radius bg-ui-3 py-2 mt-1 mr-1' />
                  <div className='col-sm radius bg-ui-3 py-2 mt-1' />
                </div>
                <div className='row mx-0'>
                  <div className='col-sm radius bg-ui-3 py-2 mt-1 mr-1' />
                  <div className='col-sm radius bg-ui-3 py-2 mt-1' />
                </div>
                <div className='row mx-0'>
                  <div className='col-sm py-2 mt-1 mr-1' />
                  <div className='col-sm radius bg-ui-3 py-2 mt-1' />
                </div>
              </div>
            </div>
            <div className='col-12 checkout-step row px-2 border-bottom border-color-ui-3 mx-0'>
              <div className='col-auto px-1'>
                <div className='row mx-0 align-items-center h-100'>
                  <div className='col-1 px-2 radius bg-ui-3 py-2' />
                </div>
              </div>
              <div className='col'>
                <div className='row mx-0 align-items-center h-100'>
                  <div className='col-1 px-5 radius bg-ui-3 py-1' />
                </div>
              </div>
            </div>
            <div className='col-12 checkout-step row px-2 border-bottom border-color-ui-3 mx-0'>
              <div className='col-auto px-1'>
                <div className='row mx-0 align-items-center h-100'>
                  <div className='col-1 px-2 radius bg-ui-3 py-2' />
                </div>
              </div>
              <div className='col'>
                <div className='row mx-0 align-items-center h-100'>
                  <div className='col-1 px-5 radius bg-ui-3 py-1' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='checkout-side col-12 col-md-4 mb-3 mb-md-0 mt-2 mt-md-0 px-0 py-0'>
        <div className='col-12 border-ui-3 radius bg-white px-0 py-0 pb-2'>
          <div className='col-12 py-3 px-3 mx-0 border-color-ui-3 border-bottom'>
            <div className='col-10 px-5 radius bg-ui-3 py-1' />
          </div>
          <div className='col-12 row pb-2 px-2 mx-0 border-bottom border-color-ui-3'>
            <div className='col-5 mt-2'>
              <div className='col-12 px-5 radius bg-ui-3 py-1' />
            </div>
            <div className='col-2 mt-2' />
            <div className='col-5 mt-2'>
              <div className='col-12 px-5 radius bg-ui-3 py-1' />
            </div>
          </div>
          <div className='col-12 row pb-2 px-2 mx-0 border-bottom border-color-ui-3'>
            <div className='col-5 mt-2'>
              <div className='col-12 px-5 radius bg-ui-3 py-1' />
            </div>
            <div className='col-2 mt-2' />
            <div className='col-5 mt-2'>
              <div className='col-12 px-5 radius bg-ui-3 py-1' />
            </div>
          </div>
          <div className='col-12 row pb-0 px-2 mx-0'>
            <div className='col-5 mt-2'>
              <div className='col-12 px-5 radius bg-ui-3 py-1' />
            </div>
            <div className='col-2 mt-2' />
            <div className='col-5 mt-2'>
              <div className='col-12 px-5 radius bg-ui-3 py-1' />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default CheckoutPlaceholder



// WEBPACK FOOTER //
// ./src/features/Checkout/CheckoutPlaceholder.js